/** Only publish hreflang pairs for real, reviewed translations. */
export const translatedPaths = [
  "getting-started/overview",
  "getting-started/quickstart-txadmin",
  "getting-started/license-key",
  "getting-started/vanilla-server",
  "ops/artifacts",
  "ops/networking",
  "txadmin/overview",
  "scripting/lua-basics",
  "scripting/nui",
  "reference/natives",
] as const;

export const SITE_ORIGIN = "https://fivemdocs.com";

export function hasGermanTranslation(path: string): boolean {
  return (translatedPaths as readonly string[]).includes(path.replace(/^\/+|\/+$/g, ""));
}

export function getLanguageAlternatesForEnglish(path: string) {
  if (!hasGermanTranslation(path)) return undefined;
  return {
    en: `${SITE_ORIGIN}/${path}`,
    de: `${SITE_ORIGIN}/de/${path}`,
  };
}

export function getGermanGuidePath(path: string): string {
  return `/de/${path}`;
}

export function getEnglishGuidePath(path: string): string {
  return `/${path}`;
}
